import type {MapCoordinates} from '../../model';

export type {MapCoordinates};

const DEFAULT_ZOOM = 13;

export function mapEmbedUrl({lat, lng}: MapCoordinates, zoom: number = DEFAULT_ZOOM): string {
  return `https://www.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed`;
}

export function mapShareUrl({lat, lng}: MapCoordinates): string {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
}
